import { useEffect, useContext } from 'react';
import {
  FormContext,
  useFormSelector,
  useEventCallback,
} from '@eas/common-web';
import { StepSubjectForm } from './step-subject-types';
import { ProcessForm } from '../irz-facility-split-types';

export function useStepSubject(allValues: ProcessForm) {
  const { setFieldValue } = useContext(FormContext);

  const { irzId } = useFormSelector(
    ({ operatorDefaultIrzId }: StepSubjectForm) => ({
      irzId: operatorDefaultIrzId,
    })
  );

  const resetValues = useEventCallback(() => {
    setFieldValue('operatorDefaultIrzId', allValues.mainFacility?.id);
    setFieldValue('operator', allValues.mainFacility?.operator);
  });

  /**
   * If the facility was changed in the first step, we need to reset the form,
   * to have correct default values.
   */
  useEffect(() => {
    if (irzId !== allValues.mainFacility?.id) {
      resetValues();
    }
  }, [allValues.mainFacility?.id]);
}
